import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslations from './locales/en.json'
import koTranslations from './locales/ko.json'

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // initialize i18next
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      ko: {
        translation: koTranslations
      }
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ko'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    defaultNS: 'translation',
    
    // language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'seacuredb_language'
    },
    
    interpolation: {
      escapeValue: false // react already escapes
    },
    
    react: {
      useSuspense: false
    }
  })

const syncDocumentLanguage = (language: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language.split('-')[0] === 'ko' ? 'ko' : 'en'
  }
}

syncDocumentLanguage(i18n.resolvedLanguage ?? i18n.language ?? 'en')
i18n.on('languageChanged', syncDocumentLanguage)

export default i18n

